<template>
<div>
    <v-card flat>
    <v-layout align-content-center>
        <v-card-title primary-title>
            <div>
                <div class="headline">Current Teams</div>
            </div>
        </v-card-title>
    </v-layout>
    <v-container fluid flat grid-list-xl>
        <v-layout row v-for="i in Math.ceil(Teams.length / 2)" v-bind:key='i'>
            <v-flex xs6
        v-for="Team in Teams.slice((i - 1) * 2, i * 2)"
        v-bind:key="Team.id">
                <Team v-bind:Team="Team"/>
            </v-flex>
        </v-layout>
    </v-container>
    </v-card>
</div>
</template>

<script>
import Team from './Team'
export default {
    name: 'Teams',
    components: {
        Team,
    },
    props:[
        'Teams'
    ],
}
</script>


